import { gql } from '@apollo/client';

export const SET_TASK_ASSIGNEE_BY_EMAIL = gql`
  mutation SetTaskAssigneeByEmail($taskId: IdentifierType!, $userEmail: String!) {
    setTaskAssigneeByEmail(taskId: $taskId, userEmail: $userEmail) {
      ok
    }
  }
`;
